export default __webpack_public_path__ + "24bc8de62f435b144aa258d17b5aa289.jpg";